//#region IMPORT
import React, { useRef, useState } from 'react';
import TRA_NEW_05_HAN from './TRA_NEW_05_HAN';
import { useNavigate } from 'react-router-dom';
import Commons from '../../../../../Services/Common/Common';
import Global from '../../../../../Services/Common/Global';
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../../../../../Reducer/SnackbarReducer';
import {
  closeLoading,
  showLoading,
} from '../../../../../Reducer/LoadingReducer';
import dayjs from 'dayjs';
import useDelete from '../../../../../hooks/useDeleteN';
import {
  useDelete1,
  useSave1,
  useSearch1,
  useSearch2,
} from './TRA_NEW_05_HAN_QUERY';
import { useSave } from '../../../../../hooks/useSaveN';
import { TRA_NEW_05_HAN_Schema } from './TRA_NEW_05_HAN_Schema';
import usePartialRefresh from '../../../../../hooks/usePartialRefresh';
import { toPreviewSrc } from '../../../../../util';
import {
  BuildTbmContentFields,
  GetHanAttendanceCounts,
  DetectReportImageMime,
} from './TRA_NEW_05_HAN_ReportData';
//#endregion
const SCREEN_MENU_ID = 'TrainingPage';

function TRA_NEW_05_HANF(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userInfo, lanInfo } = useSelector((state) => state.BaseInfo);
  const searchInfo = useSelector((state) => state.SearchInfo);

  const rowClickData = useRef(null);
  //교육현황 그리드
  const gridRef1 = useRef();
  const [rowData1, setRowData1] = useState([]); // 교육현황 그리드 데이터
  const [selectedRowData1, setSelectedRowData1] = useState([]); // 교육현황 그리드 클릭 시 데이터
  const [changedRowData1, setChangedRowData1] = useState([]); // 교육현황 그리드 변경 시 데이터
  const [deletedRowData1, setDeletedRowData1] = useState([]); // 교육현황 그리드 삭제 시 데이터
  const selectedRowNosRef1 = useRef(new Set());
  const lastCheckedIndexRef1 = useRef(null);
  const currentRowIndexRef1 = useRef(null);
  const sessionCdRef = useRef(''); // 셀 클릭 시 tbmCd
  const [modalToggle1, setModalToggle1] = useState(false);
  // 일지 미리보기 - SAM_BASIC_02F.js의 작업허가서 미리보기와 동일한 구조
  // (FilePreview 컴포넌트 + saveName/filePath/previewFilePath 필드를 담은 행 데이터)
  const [previewRowData, setPreviewRowData] = useState([]);
  const [previewLoading, setPreviewLoading] = useState(false);
  const previewBlobUrlRef = useRef('');
  //#endregion
  const { handlePartialRefresh } = usePartialRefresh({
    gridRef: gridRef1,
    changedRowData: changedRowData1,
    setChangedRowData: setChangedRowData1,
    setRowData: setRowData1,
    getKeyFromRow: (row) => row.employeeNo,
    getKeyFromResult: (result) => result.employeeNo,
  });
  const delete1 = useDelete1();

  const deleteHandler1 = useDelete({
    gridRef: gridRef1,
    deleteMutation: delete1,
    updateDeleted: setDeletedRowData1,
    updateRowData: setRowData1,
    deletedRowData: deletedRowData1,
    rowData: rowData1,
    setChangedRowData: setChangedRowData1,
  });
  //#region 조회
  //교육현황 조회(_value1:사업장코드)
  const { refetch: Search1 } = useSearch1({
    onSuccess: async (rows) => {
      setRowData1(rows);
    },
  });
  //참석장 정보 조회(value1: TBM코드) - 일지 미리보기 생성 시 참석자명단 조합용으로만 사용
  const { runAsync: Search2Async } = useSearch2();

  //#endregion
  //#region 저장
  //교육현황 저장
  const { runAsync: Save1Async } = useSave1();
  const { run: Save1 } = useSave({
    menuId: SCREEN_MENU_ID,
    schema: TRA_NEW_05_HAN_Schema,
    getChangedRows: () => changedRowData1.filter((row) => !row.deleteYn),
    getDeletedRows: () => deletedRowData1,

    requestDelete: deleteHandler1.DeleteLogic,

    requestSave: (rows) => Save1Async(rows),

    onSuccessRefresh: async () => {
      ResetLogic1();
      await Search1();
    },
    partialRefresh: ({ saveResult, changedRows }) =>
      handlePartialRefresh({
        saveResult,
        changedRows,
        searchLogic: Search1,
      }),
  });

  //#endregion
  //#region 나머지 함수
  // 이미지를 base64로 변환하는 함수
  const getBase64ImageSafe = async (url) => {
    try {
      if (!url || typeof url !== 'string' || url.trim() === '') {
        return null;
      }

      const fullUrl = /^(https?:|data:image\/|blob:)/i.test(url)
        ? url
        : `${Global.file.useUrl}files/${fixUrl(url)}`;

      const response = await fetch(fullUrl, {
        method: 'GET',
        cache: 'no-cache',
      });

      if (!response.ok) {
        console.warn('파일 없음 또는 접근 불가:', fullUrl, response.status);
        return null;
      }

      let blob = await response.blob();
      if (!blob.type.startsWith('image/')) {
        const bytes = new Uint8Array(await blob.slice(0, 12).arrayBuffer());
        const imageType = DetectReportImageMime(bytes);
        if (!imageType) return null;
        blob = new Blob([blob], { type: imageType });
      }

      // Blob 크기 확인 (너무 큰 파일 방지)
      if (blob.size === 0) {
        console.warn('빈 파일:', fullUrl);
        return null;
      }

      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (e) {
      console.warn('이미지 변환 오류:', e);
      return null;
    }
  };

  // 교육현황(rows)으로부터 TBM 일지 레포트 요청 데이터(printData)를 생성
  // 인쇄(PrintLogic1)와 일지 미리보기(PreviewLogic1)가 공통으로 사용
  const BuildPrintData = async (rows) => {
    let attendeeTableData = []; // 참석자명단 테이블 데이터
    const imageStatus = { missing: 0 };

    // 검색 연월 추출 (currentYear, currentMonth 사용)
    const currentYear = searchInfo?.currentYear;
    const currentMonth = searchInfo?.currentMonth;
    let year = '';
    let month = '';

    if (currentYear && currentMonth) {
      year = currentYear.toString();
      month = currentMonth.toString();
    } else {
      // 날짜가 없으면 현재 연월 사용
      const now = dayjs();
      year = now.format('YYYY');
      month = now.format('MM');
    }

    // 시간 포맷팅 함수 (HH:mm)
    const FormatTime = (dateValue) => {
      if (!dateValue) return '';
      const date = new Date(dateValue);
      if (isNaN(date.getTime())) return '';

      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');

      return `${hours}:${minutes}`;
    };

    // 부서명 조합 함수 (DEP_NM1, DEP_NM2, DEP_NM3, DEP_NM4 중 가장 하위 부서명)
    const getDepartmentName = (dep) => {
      if (dep?.depNm4 && dep.depNm4.trim() !== '') return dep.depNm4;
      if (dep?.depNm3 && dep.depNm3.trim() !== '') return dep.depNm3;
      if (dep?.depNm2 && dep.depNm2.trim() !== '') return dep.depNm2;
      if (dep?.depNm1 && dep.depNm1.trim() !== '') return dep.depNm1;
      if (dep?.depNm && dep.depNm.trim() !== '') return dep.depNm;
      return '';
    };

    // 경로에서 파일명만 추출 (비디오/도면/플랜 표시용)
    const fileNameOnly = (path) => {
      if (!path || typeof path !== 'string') return '';
      const parts = path.replace(/\\/g, '/').split('/');
      return parts.pop() || '';
    };

    // 잠재위험요인(여러 개)을 TableData3 행 배열로 변환 - 대책은 여기 포함하지 않음
    // 대책(1개)은 HeaderData.TBM_COUNTERMEASURE로 표 밖에 별도 표시
    const BuildHazardTableData = (contentFields) =>
      (contentFields.hazards || []).map((hazard, idx) => ({
        NO: idx + 1,
        HAZARD: hazard,
      }));

    // 첫 번째 항목의 회의일시와 회의장소 추출 (HeaderData용)
    let meetingYear = '';
    let meetingMonth = '';
    let meetingDay = '';
    let meetingStartTime = '';
    let meetingEndTime = '';
    let firstMeetingAddress = '';
    let headerTbmTitle = '';
    let headerTbmContent = '';
    let headerWorkContent = '';
    let headerWorkLocationList = [];
    let headerHazardTableData = [];
    let headerCountermeasure = ''; // 잠재위험요인에 대한 대책(공통 1개, 표 밖에 별도 표시)
    let headerHostDepNm = '';
    let headerHostNm = '';
    let headerHostRank = '';
    let hostAffiliationNm = '';
    let headerVideoFileName = '';
    let headerFileFileName = '';
    let headerPlanFileName = '';
    // 출근/참석/미참석 인원 (TBM 리더확인 하단 영역)
    let headerAttendCnt = 0; // 현재 API는 현장 출근 인원 대신 세션 등록 총원을 제공
    let headerTbmAttendCnt = 0; // 완료 인원에는 리더도 포함
    let headerTbmAbsentCnt = 0;
    if (rows.length > 0 && rows[0]) {
      const firstRow = rows[0];
      if (firstRow.tbmDate) {
        const date = new Date(firstRow.tbmDate);
        if (!isNaN(date.getTime())) {
          meetingYear = date.getFullYear().toString().slice(-2); // 뒤 2자리만
          meetingMonth = (date.getMonth() + 1).toString().padStart(2, '0');
          meetingDay = date.getDate().toString().padStart(2, '0');
        }
      }
      meetingStartTime = FormatTime(firstRow.startDt);
      meetingEndTime = FormatTime(firstRow.endDt);
      firstMeetingAddress = firstRow.tbmAddress || '';
      headerTbmTitle = firstRow.tbmTitle || '';
      headerTbmContent = firstRow.tbmContent || '';
      const headerContentFields = BuildTbmContentFields(headerTbmContent);
      headerWorkContent = headerContentFields.workContent;
      headerWorkLocationList = headerContentFields.workLocationList;
      headerHazardTableData = BuildHazardTableData(headerContentFields);
      headerCountermeasure = headerContentFields.countermeasure;
      headerHostDepNm = firstRow.hostDepNm || '';
      headerHostNm = firstRow.hostNm || '';
      headerHostRank = firstRow.hostRank || '';
      hostAffiliationNm = firstRow.hostAffiliationNm || '';
      headerVideoFileName = fileNameOnly(firstRow.videoPath);
      headerFileFileName = fileNameOnly(firstRow.filePath);
      headerPlanFileName = fileNameOnly(firstRow.planPath);
      headerAttendCnt = firstRow.userCnt;
    }

    // 헤더용 호스트서명·회의사진 (Telerik: 파일경로 X, base64)
    let headerHostSignBase64 = '';
    let headerEntryPhotoBase64 = '';
    const firstForHeader = rows[0];
    if (firstForHeader) {
      if (firstForHeader.hostSignPath) {
        try {
          const b64 = await getBase64ImageSafe(firstForHeader.hostSignPath);
          if (!b64) imageStatus.missing++;
          if (b64 && b64.startsWith('data:image/')) {
            headerHostSignBase64 = b64.replace(
              /^data:image\/[a-z0-9.+-]+;base64,/i,
              ''
            );
          }
        } catch (e) {
          /* empty */
        }
      }
      if (firstForHeader.entryPath) {
        try {
          const b64 = await getBase64ImageSafe(firstForHeader.entryPath);
          if (!b64) imageStatus.missing++;
          if (b64 && b64.startsWith('data:image/')) {
            headerEntryPhotoBase64 = b64.replace(
              /^data:image\/[a-z0-9.+-]+;base64,/i,
              ''
            );
          }
        } catch (e) {
          /* empty */
        }
      }
    }

    // rows의 각 항목에 대해 반복하여 조회 및 인쇄
    for (let index = 0; index < rows.length; index++) {
      const selectedRow = rows[index];
      if (!selectedRow.sessionCd) continue;

      const sessionCd = selectedRow.sessionCd;
      const row = selectedRow;

      // useSearch2 훅의 runAsync를 사용하여 참석자 정보 조회
      const searchParams = {
        sessionCd: sessionCd,
      };
      const attendeeData = await Search2Async(
        searchParams,
        {} // onSuccess 콜백 없이 데이터만 반환받기 위해 빈 객체 전달
      );

      if (index === 0) {
        const counts = GetHanAttendanceCounts(
          attendeeData || [],
          headerAttendCnt
        );
        headerAttendCnt = counts.total;
        headerTbmAttendCnt = counts.completed;
        headerTbmAbsentCnt = counts.absent;
      }

      if (attendeeData && attendeeData.length > 0) {
        // 참석자 정보를 비동기로 처리하여 서명 사진을 base64로 변환
        const processedAttendees = await Promise.all(
          attendeeData.map(async (attendee) => {
            // 서명 사진 경로 확인 (FILE_PATH, SIGNATURE_PATH, CHECK_PATH 등)
            const signaturePath = attendee.signImagePath || '';

            // 서명 사진을 base64로 변환
            let signatureBase64 = '';
            if (signaturePath) {
              try {
                const base64Full = await getBase64ImageSafe(signaturePath);
                if (!base64Full) imageStatus.missing++;
                if (base64Full && base64Full.startsWith('data:image/')) {
                  signatureBase64 = base64Full.replace(
                    /^data:image\/[a-z0-9.+-]+;base64,/i,
                    ''
                  );
                }
              } catch (signatureError) {
                /* empty */
              }
            }

            const affiliationNm = attendee.affiliationNm || '';
            const depNm = getDepartmentName(attendee) || '';
            const rank = attendee.rank || '';
            const userNm = attendee.userNm || '';
            const hostYn = attendee.hostYn || '';

            return {
              rank: rank,
              depNm: affiliationNm || depNm,
              userNm: userNm,
              signature: signatureBase64,
              hostYn: hostYn,
              userId: attendee.userId,
            };
          })
        );
        const processedForTable = processedAttendees.filter(
          (attendee) =>
            attendee.hostYn !== 'Y' &&
            !(row.hostId && attendee.userId === row.hostId)
        );

        if (index === 0 && !headerHostSignBase64) {
          const host = processedAttendees.find(
            (attendee) =>
              attendee.hostYn === 'Y' ||
              (row.hostId && attendee.userId === row.hostId)
          );
          headerHostSignBase64 = host?.signature || '';
        }

        // 참석자명단을 좌/중/우 3열로 분리
        const colSize = Math.ceil(processedForTable.length / 3);
        const leftList = processedForTable.slice(0, colSize); // 좌측
        const middleList = processedForTable.slice(colSize, colSize * 2); // 중앙
        const rightList = processedForTable.slice(colSize * 2); // 우측

        // 세 리스트 중 길이가 긴 값 기준으로 행 생성
        const maxLength = Math.max(
          leftList.length,
          middleList.length,
          rightList.length
        );

        // 참석자명단 테이블 데이터에 좌/중/우 분리하여 추가
        for (let i = 0; i < maxLength; i++) {
          attendeeTableData.push({
            TBM_CD: row.sessionCd || '', // 세션코드 (참조용)
            TBM_TITLE: row.tbmTitle || '', // 교육명 (참조용)
            // 좌측 참석자
            DEP_NM1: [leftList[i]?.depNm, leftList[i]?.rank]
              .filter(Boolean)
              .join(' / '),
            USER_NM1: leftList[i]?.userNm || '', // 성 명 (좌측)
            SIGNATURE1: leftList[i]?.signature || '', // 서 명 (좌측, base64)
            // 중앙 참석자
            DEP_NM2: [middleList[i]?.depNm, middleList[i]?.rank]
              .filter(Boolean)
              .join(' / '),
            USER_NM2: middleList[i]?.userNm || '', // 성 명 (중앙)
            SIGNATURE2: middleList[i]?.signature || '', // 서 명 (중앙, base64)
            // 우측 참석자
            DEP_NM3: [rightList[i]?.depNm, rightList[i]?.rank]
              .filter(Boolean)
              .join(' / '),
            USER_NM3: rightList[i]?.userNm || '', // 성 명 (우측)
            SIGNATURE3: rightList[i]?.signature || '', // 서 명 (우측, base64)
          });
        }
      }
    }

    // 한라기업(PL_0006) 전용 TBM일지 화면 - 항상 한라 전용 리포트 사용
    const printData = {
      FileName: 'TRA_BASIC_02_HAN',
      HeaderData: JSON.stringify({
        YEAR: year,
        MONTH: month,
        MEETING_YEAR: meetingYear, // 회의일시 - 연도 (뒤 2자리)
        MEETING_MONTH: meetingMonth, // 회의일시 - 월
        MEETING_DAY: meetingDay, // 회의일시 - 일
        MEETING_START_TIME: meetingStartTime, // 회의일시 - 시작시간 (HH:mm)
        MEETING_END_TIME: meetingEndTime, // 회의일시 - 종료시간 (HH:mm)
        TBM_ADDRESS: firstMeetingAddress, // 회의장소
        TBM_TITLE: headerTbmTitle,
        // TBM_CONTENT: 구양식 호환용 - 장소별 작업내용을 읽을 수 있는 텍스트로 변환(raw JSON 아님)
        TBM_CONTENT: headerWorkContent,
        WORK_CONTENT: headerWorkContent, // 작업 내용(장소별 텍스트 합본, 참고용)
        HOST_SIGN_PATH: headerHostSignBase64,
        HOST_NM: headerHostNm,
        HOST_POSITION: headerHostRank,
        HOST_DEP_NM: hostAffiliationNm || headerHostDepNm,
        TBM_COUNTERMEASURE: headerCountermeasure, // 잠재위험요인에 대한 대책(공통 1칸, TableData3 밖에 별도 표시)
        ATTEND_CNT: headerAttendCnt, // 금일 출근 인원
        TBM_ATTEND_CNT: headerTbmAttendCnt, // TBM 참석 인원
        TBM_ABSENT_CNT: headerTbmAbsentCnt, // 미참석 인원
        // 현행 세션 조회에는 기타사항 필드가 없다.
        // 구형 TBM.REMARK나 작업허가서.ETC_REMARK는 별도 문서이므로 임의로 합치지 않는다.
        ETC_CONTENT: '',
        ENTRY_PATH: headerEntryPhotoBase64,
        VIDEO_FILE_NAME: headerVideoFileName,
        FILE_FILE_NAME: headerFileFileName,
        PLAN_FILE_NAME: headerPlanFileName,
      }),
      // 작업장소/작업내용 표 - 선택한 장소 수만큼만 배열에 담김: [{LOCATION, CONTENT}, ...]
      TableData: JSON.stringify(headerWorkLocationList),
      TableData2: JSON.stringify(attendeeTableData), // 참석자명단 테이블 데이터 (DEP_NM, USER_NM, SIGNATURE 컬럼)
      // 잠재위험요인 표 - [{NO, HAZARD}, ...] 여러 줄. 대책은 HeaderData.TBM_COUNTERMEASURE로 표 밖에 한 번만 표시
      TableData3: JSON.stringify(headerHazardTableData),
    };

    if (imageStatus.missing > 0) {
      dispatch(
        showSnackbar({
          message: `서명·사진 ${imageStatus.missing}건을 불러오지 못했습니다. 파일 상태를 확인해 주세요.`,
          type: 'warning',
        })
      );
    }
    return printData;
  };

  //인쇄 함수
  const PrintLogic1 = async () => {
    // 선택된 행 확인
    if (!selectedRowData1 || selectedRowData1.length === 0) {
      dispatch(
        showSnackbar({
          message: '인쇄할 항목을 선택하세요.',
          type: 'warning',
        })
      );
      return Promise.resolve(); // Promise를 반환하여 finally가 실행되도록 함
    }

    dispatch(showLoading());
    try {
      const printData = await BuildPrintData(selectedRowData1);

      await Commons.Axios(
        'report',
        Global.base.useUrl + Global.urls.Reports.reports,
        printData
      ).then((response) => {
        const blobUrl = URL.createObjectURL(response.data);
        window.open(blobUrl, '_blank'); // 새 탭에서 열기
      });
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    } finally {
      dispatch(closeLoading());
    }
  };

  // 일지 미리보기 생성 함수 (선택된 단일 행 기준)
  const PreviewLogic1 = async (row) => {
    if (!row?.sessionCd) {
      if (previewBlobUrlRef.current) {
        URL.revokeObjectURL(previewBlobUrlRef.current);
        previewBlobUrlRef.current = '';
      }
      setPreviewRowData([]);
      return;
    }

    setPreviewLoading(true);
    try {
      const printData = await BuildPrintData([row]);
      const response = await Commons.Axios(
        'report',
        Global.base.useUrl + Global.urls.Reports.reports,
        printData
      );

      if (previewBlobUrlRef.current) {
        URL.revokeObjectURL(previewBlobUrlRef.current);
      }
      const blobUrl = URL.createObjectURL(response.data);
      previewBlobUrlRef.current = blobUrl;
      setPreviewRowData([
        {
          saveName: `TBM일지_${row.sessionCd}.pdf`,
          filePath: blobUrl,
          previewFilePath: blobUrl,
        },
      ]);
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    } finally {
      setPreviewLoading(false);
    }
  };
  const fixUrl = (url) => {
    if (!url || typeof url !== 'string') return ''; // 또는 적절한 fallback
    const parts = url.split('/');
    const fileName = parts.pop(); // 파일 이름 분리
    const encodedFileName = encodeURIComponent(fileName);
    return [...parts, encodedFileName].join('/');
  };

  // 오디오 파일 다운로드
  const DownloadLogic1 = async (audioUrl) => {
    if (!audioUrl) {
      dispatch(
        showSnackbar({
          message: '오디오 파일이 존재하지 않습니다.',
          type: 'warning',
        })
      );
      return;
    }

    try {
      // 1) 파일 경로 정리
      const filePath = fixUrl(audioUrl);
      const fileName = audioUrl.split('/').pop() || 'audio.mp3';

      const params = {
        FileName: fileName,
        Url: filePath,
      };

      // 2) Axios 요청 (백엔드에서 파일 내려줌)
      await Commons.Axios(
        'fileDown',
        Global.file.useUrl + Global.urls.Execute.UrlFileDownload,
        params
      ).then((result) => {
        const contentType = result?.headers?.['content-type'];
        const blobData = result?.data;

        if (!blobData || !contentType) {
          dispatch(
            showSnackbar({
              message: `"${fileName}" 다운로드 응답이 비정상입니다.`,
              type: 'error',
            })
          );
          return;
        }

        // 3) Blob → Object URL 생성
        const blob = new Blob([blobData], { type: contentType });
        const url = window.URL.createObjectURL(blob);

        // 4) 가짜 <a> 태그로 다운로드 트리거
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();

        // 5) 정리
        a.remove();
        window.URL.revokeObjectURL(url);

        dispatch(
          showSnackbar({
            message: `"${fileName}" 다운로드 완료`,
            type: 'success',
          })
        );
      });
    } catch (e) {
      console.error(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    }
  };

  //#endregion
  const PreviewRender = () => {
    const rowData = selectedRowData1?.[0];

    // rowData가 없으면 Hook 사용 후에도 안전하게 return
    if (!rowData) {
      return <div>파일 정보가 없습니다.</div>;
    }

    const filePath = rowData?.entryPath || '';

    if (!filePath) {
      return <div>파일 정보가 없습니다.</div>;
    }

    const ext = filePath.split('.').pop()?.toLowerCase();
    const fullUrl = toPreviewSrc(filePath);

    if (['png', 'jpg', 'jpeg'].includes(ext)) {
      return (
        <img
          src={fullUrl}
          alt="미리보기"
          style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
        />
      );
    }

    return <div>지원하지 않는 형식입니다.</div>;
  };

  const ResetLogic1 = () => {
    setRowData1([]);
    if (previewBlobUrlRef.current) {
      URL.revokeObjectURL(previewBlobUrlRef.current);
      previewBlobUrlRef.current = '';
    }
    setPreviewRowData([]);
  };

  const PopupClickEvent1 = async (e) => {
    rowClickData.current = e;
    setSelectedRowData1([e]);
    // await loadInitialFile(e.chaebun, e.seq);
    setTimeout(() => setModalToggle1(true), 100);
  };
  const handleRowSelection1 = (rowData, rowIndex) => {
    currentRowIndexRef1.current = rowIndex;
    setSelectedRowData1([rowData]);
  };
  return (
    <TRA_NEW_05_HAN
      gridId1={'grid1'}
      navigate={navigate}
      userInfo={userInfo}
      lanInfo={lanInfo}
      rowData1={rowData1}
      setRowData1={setRowData1}
      selectedRowData1={selectedRowData1}
      setSelectedRowData1={setSelectedRowData1}
      changedRowData1={changedRowData1}
      setChangedRowData1={setChangedRowData1}
      previewRowData={previewRowData}
      previewLoading={previewLoading}
      searchRef={props.searchRef}
      filterClick5={props.filterClick5}
      setFilterClick5={props.setFilterClick5}
      searchClick5={props.searchClick5}
      setSearchClick5={props.setSearchClick5}
      addClick5={props.addClick5}
      setAddClick5={props.setAddClick5}
      saveClick5={props.saveClick5}
      setSaveClick5={props.setSaveClick5}
      deleteClick5={props.deleteClick5}
      setDeleteClick5={props.setDeleteClick5}
      printClick5={props.printClick5}
      setPrintClick5={props.setPrintClick5}
      gridRef1={gridRef1}
      sessionCdRef={sessionCdRef}
      modalToggle1={modalToggle1}
      setModalToggle1={setModalToggle1}
      lastCheckedIndexRef1={lastCheckedIndexRef1}
      selectedRowNosRef1={selectedRowNosRef1}
      deletedRowData1={deletedRowData1}
      // 함수
      validateSelection={props.validateSelection}
      ResetLogic1={ResetLogic1}
      SearchLogic1={Search1}
      SaveLogic1={Save1}
      PrintLogic1={PrintLogic1}
      PreviewLogic1={PreviewLogic1}
      PopupClickEvent1={PopupClickEvent1}
      PreviewRender={PreviewRender}
      DownloadLogic1={DownloadLogic1}
      RestoreRow1={deleteHandler1.RestoreRow}
      MarkedForDeletion1={deleteHandler1.MarkedForDeletion}
      DeleteNewRow1={deleteHandler1.DeleteNewRow}
      handleRowSelection1={handleRowSelection1}
    />
  );
}

export default TRA_NEW_05_HANF;
